// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__idXlE","indicator":"styles_indicator__X7Z7n"};